export var EventNoun;
(function (EventNoun) {
    EventNoun["NETWORK"] = "network";
    EventNoun["COLLECTION"] = "collection";
    EventNoun["SPACE"] = "space";
    EventNoun["POST"] = "post";
    EventNoun["MEMBER"] = "member";
    EventNoun["MEMBER_POST_NOTIFICATION_SETTINGS"] = "memberPostNotificationSettings";
    EventNoun["REACTION"] = "reaction";
})(EventNoun || (EventNoun = {}));
export var EventVerb;
(function (EventVerb) {
    EventVerb["CREATED"] = "created";
    EventVerb["UPDATED"] = "updated";
    EventVerb["DELETED"] = "deleted";
    EventVerb["HIDDEN"] = "hidden";
    EventVerb["UNHIDDEN"] = "unhidden";
    EventVerb["ADDED"] = "added";
    EventVerb["REMOVED"] = "removed";
    EventVerb["JOINED"] = "joined";
    EventVerb["LEFT"] = "left";
})(EventVerb || (EventVerb = {}));
